export default __webpack_public_path__ + "static/media/mainlogoBlue.49b0bb53.png";